import CombineCaseDetail from '@/models/CombineCase/CombineCaseDetail';

export default class CombineCaseDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.combineCaseId  = '';
		this.combineCaseControlCard = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.qtyControlCard = '';
		this.qtyAfter = '';
		this.takenQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			combineCaseId : '0',
			combineCaseControlCard : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			qtyControlCard : '0',
			qtyAfter : '0',
			takenQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}